import { Dialog } from '@headlessui/react';
import { ReactNode } from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}

const Modal = ({ isOpen, onClose, title, children }: ModalProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4 overflow-y-auto">
        <Dialog.Panel className="bg-white rounded-lg max-w-md w-full max-h-[90vh] flex flex-col overflow-hidden my-auto">
          <Dialog.Title className="text-lg font-medium flex-shrink-0 p-6 pb-0">
            {title}
          </Dialog.Title>
          <div className="flex-1 min-h-0 overflow-y-auto p-6 pt-4">{children}</div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default Modal;
